import React from "react";

export const CONSOLE_FILTERS = [
  { id: "all", label: "Все игры" },
  { id: "switch", label: "Switch" },
  { id: "switch2", label: "Switch 2" },
];

export function isSwitch2Deal(deal) {
  return (deal?.platforms || []).some((item) => /switch\s*2/i.test(String(item)));
}

export function matchNintendoConsole(item, filter) {
  if (!filter || filter === "all") return true;
  const switch2 =
    item?.switch2 === true ||
    item?.switch2 === 1 ||
    isSwitch2Deal(item);
  return filter === "switch2" ? switch2 : !switch2;
}

function NintendoConsoleFilter({ value = "all", onChange, className = "" }) {
  return (
    <div
      className={`inline-flex overflow-hidden rounded-full border border-gray-200 bg-white dark:border-gray-600 dark:bg-[#2a2a2a] ${className}`}
      role="group"
      aria-label="Платформа"
    >
      {CONSOLE_FILTERS.map((item, index) => {
        const on = value === item.id;
        return (
          <button
            key={item.id}
            type="button"
            aria-pressed={on}
            onClick={() => onChange?.(item.id)}
            className={`px-3.5 py-1.5 text-sm font-medium transition ${
              index > 0 ? "border-l border-gray-200 dark:border-gray-600" : ""
            } ${
              on
                ? "bg-indigo-600 text-white"
                : "text-gray-600 hover:bg-gray-50 hover:text-indigo-700 dark:text-gray-200 dark:hover:bg-gray-700 dark:hover:text-white"
            }`}
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
}

export default NintendoConsoleFilter;
